import type { LocaleDictionary } from "@/i18n/types";

const nsUploadEN = {
  dragAndDrop: {
    selectFile: "Select a file",
    prompt: "or drag & drop it here",
    limitItem: ({
      typeName,
      limit,
    }: {
      typeName: string;
      limit: number;
      hasMultipleTypes: boolean;
    }) => `Up to ${limit} ${typeName}(s)`,
    limitSeparator: ", ",
    limitNote: ({ fileLimits }: { fileLimits: string }) => `(${fileLimits})`,
  },
  fileType: {
    excel: "Excel File",
    csv: "CSV File",
    json: "JSON File",
    yaml: "YAML File",
    zip: "ZIP File",
  },
  dataName: "Data Name",
  deleteButton: "Remove",
} satisfies LocaleDictionary;

export default nsUploadEN;
